/* eslint-disable no-undef */
import '../lib/vk.openapi';

let subscribe = document.querySelector('#vk_subscribe');

if (subscribe) {
  initSubscribe();
}

function initSubscribe() {
  // eslint-disable-next-line new-cap
  VK.Widgets.Subscribe('vk_subscribe', {
    soft: 1
  }, -186272569);
}

VK.Observer.subscribe('widgets.subscribed', function f() {
  jQuery.ajax({
    type: 'POST',
    url: 'index.php?option=com_jshopping&controller=vk_subscribe&task=subscribe',
    dataType: 'json'
  }).done(function (json) {
    if (json === true) {
      location.reload();
    }
  });
});

VK.Observer.subscribe('widgets.unsubscribed', function f() {
  jQuery.ajax({
    type: 'POST',
    url: 'index.php?option=com_jshopping&controller=vk_subscribe&task=unsubscribe'
  }).done(function () {
    location.reload();
  });
});
